module.exports = __webpack_public_path__ + "1.0.0-fa265927/img/cisco.73e741f3.svg";